import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthService } from './auth/auth-service';
import { NotificationPanel } from './features/notification-panel/notification-panel';
import { TopBarComponent } from './features/top-bar/top-bar';

@Component({
  imports: [RouterModule, TopBarComponent, NotificationPanel],
  selector: 'upu-root',
  templateUrl: './app.html',
  host: {
    class: 'flex flex-col min-h-screen',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly isLoggedIn = inject(AuthService).isLoggedIn;

  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  protected readonly isolatePageContent = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(
        () =>
          this.route.firstChild?.snapshot.data['isolatePageContent'] ?? false,
      ),
    ),
    { initialValue: true },
  );
}
